import React, { useState, useCallback, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Formik, Form } from 'formik'
import Loading from 'custom/assets/loaders/Loading'
import TermsAndCondition from '../../../components/TermsAndConditions/TermsAndCondition'
import '../../../styles/Auth.css'
import AuthService from '../../../services/auth.service'
import { ForgotPasswordSchema, ForgotPasswordConfirmSchema } from '../../../schemas/auth'
import '../../../styles/ForgotPassword.css'
import CheckMarkIcon from 'custom/assets/icons/requests/709510'
import InputError from '../../../components/InputError/InputError'
import { DIALOG_KEYS, AUTH_KEYS } from '../../../utils/translation-constants'
import NeoInput from '../../../components/NeoInput/NeoInput'
import NeoButton from '../../../components/NeoButton/NeoButton'
import AuthLayout from '../auth-layout'
import config from 'custom/config/environment'
import validationConfig from 'custom/config/validation.config.json'
const forgotPasswordConfig = validationConfig['forgotPassword']

export default function ForgotPassword() {
  const [message, setMessage] = useState('Message Placeholder')
  const defaultErrorMessage = 'Something went worng. Please contact Bank'
  const [loading, setLoading] = useState(false)
  const [criteria, setCriteria] = useState([])
  const [captcha, setCaptcha] = useState('')
  const [passwordPattern, setPasswordPattern] = useState(null)
  const [captchaValid, setCaptchaValid] = useState(false)
  const [stage, setStage] = useState(1)
  const [formValues, setFormValues] = useState({
    accountNumber: '',
    username: '',
    // countryCode: '',
    phoneNumber: '',
    dateOfBirth: '',
  })
  const { t } = useTranslation()
  const [countryCodes, setCountryCodes] = useState(['260', '91'])
  const customerIdentity = ['PASSPORT NO', 'NRC NO']
  const [otp, setOtp] = useState('')

  const history = useHistory()

  useEffect(() => {
    getCriteria()
  }, [])

  const getCriteria = useCallback(async () => {
    setLoading(true)
    try {
      const response = await AuthService.getPasswordCriteria()
      setCriteria(response.userPasswordCriteriaMap)
      // const pwdMaxLength = response['userPasswordCriteria'][3].value
      // const pwdMinLength = response['userPasswordCriteria'][4].value
      // const pwdMinAlphabetLength = response['userPasswordCriteria'][0].value
      // const pwdMinNumberLength = response['userPasswordCriteria'][1].value
      // const pwdMinSplCharLength = response['userPasswordCriteria'][2].value
      const pwdMaxLength = response['userPasswordCriteriaMap']['MAX_PWD_LENGTH']
      const pwdMinLength = response['userPasswordCriteriaMap']['MIN_PWD_LENGTH']
      const pwdMinAlphabetLength = response['userPasswordCriteriaMap']['ALPHABETS']
      const pwdMinNumberLength = response['userPasswordCriteriaMap']['NUMERICS']
      const pwdMinSplCharLength = response['userPasswordCriteriaMap']['SPECIAL_CHARACTERS']
      const pattern = `(?=^.{${pwdMinLength},${pwdMaxLength}}$)(?=(.*\\d){${pwdMinNumberLength}})(?=(.*[A-Za-z]){${pwdMinAlphabetLength}})(?=(.*[\\+\\- \\= \\[\\]\\{ \\}\\;\\-\\(\\)\\<\\>\\_'!@#$%^&*?\"|/,.:\`~\\\\]){${pwdMinSplCharLength}})(?!.*[\\s])^.*`
      setPasswordPattern(new RegExp(pattern))
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }, [])

  const verifyUserDetails = useCallback(
    async (data, { setSubmitting }) => {
      try {
        setSubmitting(true)
        setLoading(true)
        // if (data.identityType === 'PASSPORT NO') {
        //   data.nrcNumber = ''
        // } else {
        //   data.passportNumber = ''
        // }
        const response = await AuthService.forgotPasswordVerifyDetails({
          customerId: data.accountNumber,
          // countryCode: data.countryCode,
          mobile: data.phoneNumber,
          username: data.username,
          dob: data.dateOfBirth,
          // passport: data.passportNumber,
          // nationalId: data.nrcNumber,
        })
        setFormValues(data)
        setCaptcha(response.captchaCode)
        await getCriteria()
        setSubmitting(false)
        setLoading(false)
        setStage(2)
      } catch (err) {
        setLoading(false)
        setSubmitting(false)
      }
    },
    [getCriteria],
  )

  const changePassword = useCallback(
    async (data, { setSubmitting }) => {
      try {
        setSubmitting(true)
        const response = await AuthService.updatePassword({
          customerId: formValues.accountNumber,
          mobile: formValues.phoneNumber,
          username: formValues.username,
          dob: formValues.dateOfBirth,
          captchaValue: captcha,
          otp: data.otp,
          password: data.newPassword,
        })
        setMessage(response.message || defaultErrorMessage)
        setSubmitting(false)
        setStage(3)
      } catch (err) {
        setSubmitting(false)
      }
    },
    [captcha, formValues],
  )

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function handleKeyDown(e) {
    if (e.key === ' ') {
      e.preventDefault()
    }
  }

  function renderSuccess() {
    return (
      <div>
        {/* <div className='my-3 py-5 d-flex flex-column text-center'>
          <CheckMarkIcon />
          <p className='mt-4 text-secondary'>{message}</p> */}
        <div className='text-center' style={{ paddingBottom: 100 }}>
          <CheckMarkIcon />
          <h5 className='mt-5'>{message}</h5>

          <div className='mt-4 mx-auto px-0 col-3'>
            <NeoButton
              type='button'
              mode='newDesign'
              text={t(AUTH_KEYS.FORGOT_PASSWORD_KEYS.SUCCESS_KEYS.DONE)}
              onClick={() => {
                history.push('/landing')
              }}
            />
          </div>
        </div>
      </div>
    )
  }
  function renderForm() {
    return (
      <div>
        <Formik
          enableReinitialize
          validationSchema={ForgotPasswordSchema}
          onSubmit={verifyUserDetails}
          initialValues={formValues}>
          {({ isSubmitting, errors, touched, setFieldValue, handleChange, values }) => (
            <Form>
              <div className='auth-form'>
                <div className='my-3'>
                  <div className='form-group  my-3'>
                    <NeoInput
                      tabIndex='1'
                      showAsterisk={forgotPasswordConfig['isAccountNoRequired']}
                      name='accountNumber'
                      onChange={(value) => {
                        setFieldValue('accountNumber', value?.value)
                      }}
                      text={t(AUTH_KEYS.FORGOT_PASSWORD_KEYS.DETAILS_KEYS.ACCOUNT_NUMBER)}
                      mode='onlyNumber'
                      // mode='password'
                      // maxLength={13}
                      icon='person'
                      placeholder={t(AUTH_KEYS.FORGOT_PASSWORD_KEYS.DETAILS_KEYS.ACCOUNT_NUMBER)}
                    />
                    <InputError text={errors.accountNumber} touched={touched.accountNumber} />
                  </div>

                  <div className='form-group  my-3'>
                    <NeoInput
                      tabIndex='2'
                      showAsterisk={forgotPasswordConfig['isUserNameRequired']}
                      name='username'
                      onChange={handleChange}
                      text={t(AUTH_KEYS.FORGOT_PASSWORD_KEYS.DETAILS_KEYS.USERNAME)}
                      mode='single'
                      icon='person'
                      placeholder={t(AUTH_KEYS.FORGOT_PASSWORD_KEYS.DETAILS_KEYS.USERNAME)}
                      value={values.username}
                    />
                    <InputError text={errors.username} touched={touched.username} />
                  </div>

                  <div className='form-group  my-3'>
                    <NeoInput
                      tabIndex='3'
                      showAsterisk={forgotPasswordConfig['isPhoneNoRequired']}
                      name='phoneNumber'
                      onChange={(value) => {
                        setFieldValue('phoneNumber', value?.value)
                      }}
                      // onChange={handleChange}
                      text={t(AUTH_KEYS.FORGOT_PASSWORD_KEYS.DETAILS_KEYS.MOBILENO_WITHOUT_COUNTRY_CODE)}
                      mode='onlyNumber'
                      icon='phone'
                      placeholder={t(AUTH_KEYS.FORGOT_PASSWORD_KEYS.DETAILS_KEYS.MOBILENO_WITHOUT_COUNTRY_CODE)}
                      value={values.phoneNumber}
                    />
                    <InputError text={errors.phoneNumber} touched={touched.phoneNumber} />
                  </div>

                  <div className='form-group  my-3'>
                    <NeoInput
                      tabIndex='4'
                      showAsterisk={forgotPasswordConfig['isDOBRequired']}
                      name='dateOfBirth'
                      onChange={handleChange}
                      text={t(AUTH_KEYS.FORGOT_PASSWORD_KEYS.DETAILS_KEYS.DOB)}
                      type='date'
                      max={(function () {
                        const today = new Date()
                        const dd = today.getDate() - 1
                        const mm = today.getMonth() + 1
                        const yyyy = today.getFullYear() - config.DOB_MINOR_AGE_VALIDATION
                        return `${yyyy}-${mm < 10 ? '0' + mm : mm}-${dd < 10 ? '0' + dd : dd}`
                      })()}
                      mode='single'
                      icon='person'
                      value={values.dateOfBirth}
                    />
                    <InputError text={errors.dateOfBirth} touched={touched.dateOfBirth} />
                  </div>
                  <div className='form-group col-12'>
                    <TermsAndCondition tabIndex='5' module="PASSWORDRESET" />
                  </div>
                </div>
              </div>
              <div className='mt-3' />
              {isSubmitting === false && loading === false ? (
                <NeoButton
                  tabIndex='6'
                  text={t(AUTH_KEYS.FORGOT_PASSWORD_KEYS.DETAILS_KEYS.SUBMIT)}
                  mode='newDesign'
                  disabled={isSubmitting}
                  type='submit'
                />
              ) : (
                renderLoading()
              )}
              <div className='back-cancel-btn-container'>
                <button
                  tabIndex={'7'}
                  onClick={() => {
                    history.push('/login')
                  }}
                  className='back-cancel-btn btn btn-sm new-design-warning-text-color'
                  >
                  {t(AUTH_KEYS.FORGOT_PASSWORD_KEYS.RESET_KEYS.LOGIN)}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderResetForm() {
    return (
      <div className='ResetForm'>
        <Formik
          enableReinitialize
          validationSchema={ForgotPasswordConfirmSchema}
          onSubmit={changePassword}
          initialValues={{
            newPassword: '',
            confirmNewPassword: '',
            //captchaCode: formValues.captchaCode,
            otp: '',
          }}>
          {({ isSubmitting, errors, touched, handleChange, setFieldValue }) => (
            <Form>
              <div className='auth-form'>
                <label className='control-label'></label>
                <div className='form-group '>
                  <NeoInput
                    tabIndex='1'
                    showAsterisk={forgotPasswordConfig['isNewPasswordRequired']}
                    text={t(AUTH_KEYS.FORGOT_PASSWORD_KEYS.RESET_KEYS.NEW_PASSWORD)}
                    name='newPassword'
                    icon='lock'
                    mode='sensitiveIcon'
                    pattern={new RegExp(passwordPattern)}
                    disabled={isSubmitting}
                    onChange={handleChange}
                    type='password'
                    onKeyDown={handleKeyDown}
                    maxLength={14}
                  />
                  <InputError text={errors.newPassword} touched={touched.newPassword} />
                </div>
                <div className='my-3' />
                <div className='form-group'>
                  <NeoInput
                    tabIndex='2'
                    showAsterisk={forgotPasswordConfig['isConfirmPasswordRequired']}
                    text={t(AUTH_KEYS.FORGOT_PASSWORD_KEYS.RESET_KEYS.CONFIRM_PASSWORD)}
                    name='confirmNewPassword'
                    icon='lock'
                    mode='sensitiveIcon'
                    disabled={isSubmitting}
                    onChange={handleChange}
                    type='password'
                    maxLength={14}
                  />
                  <InputError
                    text={errors.confirmNewPassword}
                    touched={touched.confirmNewPassword}
                  />
                </div>

                <div className='my-3' />
                {/* <NeoOTPOnly setOTP={setOtp} otp={otp} /> */}
                {/* <OtpInput
                  value={otp}
                  onChange={(val) => setOtp(val)}
                  numInputs={4}
                  separator={''}
                  isInputNum={true}
                  // isInputSecure={true}
                  shouldAutoFocus={true}
                  containerStyle='justify-content-center'
                  inputStyle={{
                    width: 48,
                    height: 48,
                    fontSize: 24,
                    marginLeft: 8,
                    marginRight: 8,
                    border: 'none',
                    borderRadius: 10,
                    backgroundColor: '#FEF0EF',
                    color: '#F1604A',
                    fontWeight: 800,
                    fontSize: 18,
                    outline:'none',
                    border:'1px solid #FF9570'
                  }}
                /> */}

                <div className='form-group my-3'>
                  <NeoInput
                    tabIndex='3'
                    showAsterisk={forgotPasswordConfig['isOTPRequired']}
                    maxLength={4}
                    text={t(AUTH_KEYS.FORGOT_PASSWORD_KEYS.RESET_KEYS.OTP)}
                    type='number'
                    mode='onlyNumber'
                    onChange={(value) => {
                      setFieldValue('otp', value?.value)
                    }}
                    name='otp'
                    disabled={isSubmitting}
                  />
                  <InputError text={errors.otp} touched={touched.otp} />
                </div>
              </div>
              <div className='passwordCriteria'>
                <h6>{t(AUTH_KEYS.FORGOT_PASSWORD_KEYS.RESET_KEYS.PASSWORD_CRITERIA)}</h6>
                {/* {criteria.map((value, i) => (
                  <p key={i} className='card-text col'>
                    {value.description} : <b>{value.value}</b>
                  </p>
                ))} */}
                {Object.keys(criteria).map((key, i) => (
                  <p key={i} className='card-text col'>
                    {t(key)} : <b>{criteria[key]}</b>
                  </p>
                ))}
              </div>
              <div className='my-3'>
                {isSubmitting ? (
                  renderLoading()
                ) : (
                  <NeoButton
                    tabIndex='4'
                    text={t(AUTH_KEYS.FORGOT_PASSWORD_KEYS.RESET_KEYS.SUBMIT)}
                    mode='newDesign'
                    disabled={isSubmitting || captchaValid}
                    type='submit'
                  />
                )}
              </div>
              <div className='my-4' />
              <div className='back-cancel-btn-container'>
                <button
                  tabIndex='5'
                  onClick={() => {
                    setStage(1)
                  }}
                  className='back-cancel-btn btn btn-sm new-design-warning-text-color'>
                  {t(AUTH_KEYS.FORGOT_PASSWORD_KEYS.RESET_KEYS.BACK)}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }
  const renderSwitch = () => {
    switch (stage) {
      case 1:
        return renderForm()
      case 2:
        return renderResetForm()
      case 3:
        return renderSuccess()
      default:
        return renderForm()
    }
  }

  return (
    <AuthLayout>
      <div className='container col mt-3 ' style={{ width: '400px' }}>
        <h3 className='register-with-us-tod'>
          {t(AUTH_KEYS.FORGOT_PASSWORD_KEYS.RESET_KEYS.TITLE)}
        </h3>
        <p className='small'>{t(AUTH_KEYS.FORGOT_PASSWORD_KEYS.RESET_KEYS.SUBTITLE)}</p>
        <div className='my-4' />
        {renderSwitch()}
      </div>
    </AuthLayout>
  )
}
